import { render, staticRenderFns } from "./AlbumList.vue?vue&type=template&id=33d4fecf&scoped=true&"
import script from "./AlbumList.vue?vue&type=script&lang=js&"
export * from "./AlbumList.vue?vue&type=script&lang=js&"
import style0 from "./AlbumList.vue?vue&type=style&index=0&id=33d4fecf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4fecf",
  null
  
)

export default component.exports